import { AddLayerObject } from 'maplibre-gl';

import {
  AcresMapboxLayerIds,
  AcresMapboxVectorSourceLayerIds,
} from '@/mapbox-layers';

export const wetlandsLayer = (tileSourceUrl): AddLayerObject => ({
  id: AcresMapboxLayerIds.WETLANDS,
  paint: {
    'line-color': '#0000ff',
    'line-dasharray': [1, 1],
    'line-width': 3,
  },
  source: {
    maxzoom: 13,
    minzoom: 10,
    tiles: [`${tileSourceUrl}{z}/{x}/{y}`],
    type: 'vector',
  },
  'source-layer': AcresMapboxVectorSourceLayerIds.WETLANDS,
  type: 'line',
});
